import {
  phoneNumber,
} from 'constants/validation/presets'

export const validationRules = {
  phoneNumber
}
